<template>
    <div>
        <Loader v-if="isLoadingTrainingOutfits" />

        <div v-if="!isLoadingTrainingOutfits">
            <p class="cta">Keep swiping! We're learning your style...</p>
            <Logo class="logo"></Logo>
            <OutfitSwipe
                v-if="outfitCurrent"
                :outfitCurrent="outfitCurrent"
                :noOutfitsForTheseFilters="false"
                :visitProduct="false"
                :saveOutfit="saveOutfit"
                :rejectOutfit="rejectOutfit"
            />
        </div>
    </div>
</template>

<script>
    import Mixins from "../../../mixins/mixins";
    import {mapGetters} from 'vuex';
    import Loader from '../../common/loader.vue';
    import Logo from '../../header/logo.vue';
    import OutfitSwipe from '../../style-selection/outfit-swipe.vue';

    export default {
        mixins: [Mixins],
        components: {
            Loader,
            Logo,
            OutfitSwipe
        },
        created() {
            this.$store.commit('menu/hideHeader');
            // If we don't have any outfits, end training, to avoid breaking app
            this.$store.dispatch("onboarding/loadTrainingOutfits").then(outfits => {
                if (outfits.length === 0) {
                    this.trainingCompleted();
                }
            });
        },
        computed: {
            ...mapGetters({
                isLoadingTrainingOutfits: 'onboarding/isLoadingTrainingOutfits',
                outfitCurrent: 'onboarding/currentTrainingOutfit',
                hasMoreTrainingOutfits: 'onboarding/hasMoreTrainingOutfits'
            })
        },
        methods: {
            getNext() {
                if (this.hasMoreTrainingOutfits) {
                    this.$store.commit('onboarding/nextTrainingOutfit');
                } else {
                    this.trainingCompleted();
                }
            },
            trainingCompleted() {
                this.$parent.$emit('completedTraining');
            },
            saveOutfit() {
                let outfit = this.outfitCurrent;
                this.$store.dispatch({
                    type: 'onboarding/likeOutfit',
                    outfit
                }).finally(this.getNext());
            },
            rejectOutfit() {
                let outfit = this.outfitCurrent;
                this.$store.dispatch({
                    type: 'onboarding/rejectOutfit',
                    outfit
                }).finally(this.getNext());
            }
        }
    };
</script>

<style lang="scss" scoped>
.cta {
    font-family: 'Lato';
    font-weight: 300;
    margin: 30px 0 20px;
    text-align: center;
}
.logo {
    width: 135px;
    margin: 0 auto 40px auto;
    display: block;
}
.training-step-body {
    .main-outfit-container {
        height: 75vh;
    }
}
</style>
